import { useTranslation, UseTranslationResponse } from 'react-i18next';

export function usePlayerTranslation(): UseTranslationResponse<'player', ''> {
  return useTranslation('player');
}
